'use strict';

const BaseScene = require('./base-scene');
const Button = require('../ui/button');
const { COLORS, GAME_WIDTH } = require('../config/constants');
const { drawGlowText, drawText, drawPanel, drawPlane } = require('../ui/draw');

const TYPES = [{ key: 'PLANE', label: '机体' }, { key: 'TRAIL', label: '尾焰' }, { key: 'TITLE', label: '称号' }];

class CosmeticsScene extends BaseScene {
  enter() {
    this.type = 'PLANE'; this.loading = false; this.error = '';
    this.items = (this.app.dashboard && this.app.dashboard.cosmetics) || [];
    this.buildButtons();
    this.app.cloud.cosmetics().then((data) => this.applyData(data)).catch(() => { this.error = '网络不可用，显示缓存外观'; });
  }

  applyData(data) {
    this.items = data.items || [];
    if (this.app.dashboard) {
      this.app.dashboard.cosmetics = this.items;
      this.app.dashboard.selection = data.selection;
      this.app.storage.saveDashboard(this.app.dashboard);
    }
    this.buildButtons();
  }

  select(item) {
    if (!item.unlocked || item.selected || this.loading) return;
    this.loading = true;
    this.app.cloud.selectCosmetic(item.type, item.key).then((data) => {
      this.loading = false; this.applyData(data);
    }).catch((error) => { this.loading = false; this.error = error.message || '保存失败'; });
  }

  unlockLabel(item) {
    const unlock = item.unlock || {};
    if (unlock.type === 'LEVEL') return `等级 ${unlock.value} 解锁`;
    if (unlock.type === 'ACHIEVEMENT') return '完成对应成就解锁';
    return '默认解锁';
  }

  buildButtons() {
    this.buttons = TYPES.map((item, index) => new Button({
      x: 58 + index * 218, y: 170, width: 198, height: 70, label: item.label,
      variant: item.key === this.type ? 'primary' : 'secondary', fontSize: 26,
      onTap: () => { this.type = item.key; this.buildButtons(); }
    }));
    this.items.filter((item) => item.type === this.type).slice(0, 5).forEach((item, index) => {
      if (!item.unlocked) return;
      this.buttons.push(new Button({
        x: 500, y: 305 + index * 155, width: 155, height: 64,
        label: item.selected ? '使用中' : '选择', variant: item.selected ? 'primary' : 'secondary',
        disabled: item.selected || this.loading, fontSize: 24, onTap: () => this.select(item)
      }));
    });
    this.buttons.push(new Button({ x: 235, y: 1175, width: 280, height: 82, label: '返回首页', variant: 'secondary', onTap: () => this.app.switchScene('home') }));
  }

  render(ctx) {
    drawGlowText(ctx, '飞行外观', GAME_WIDTH / 2, 100, 54, COLORS.cyan);
    const items = this.items.filter((item) => item.type === this.type).slice(0, 5);
    items.forEach((item, index) => {
      const y = 280 + index * 155;
      drawPanel(ctx, 70, y, 610, 125, { radius: 18, stroke: item.selected ? item.color : 'rgba(145,164,201,.22)' });
      if (item.type === 'PLANE') drawPlane(ctx, 125, y + 63, .55, item.unlocked ? item.color : '#52617d');
      else { ctx.fillStyle = item.unlocked ? item.color : '#52617d'; ctx.fillRect(100, y + 52, 54, 20); }
      drawText(ctx, item.label, 190, y + 42, 27, item.unlocked ? COLORS.text : COLORS.muted, 'left', 'bold');
      drawText(ctx, item.unlocked ? (item.selected ? '当前装备' : '已解锁') : this.unlockLabel(item), 190, y + 84, 21, item.selected ? COLORS.success : COLORS.muted, 'left');
    });
    if (!items.length) drawText(ctx, '暂无外观数据', GAME_WIDTH / 2, 560, 28, COLORS.muted);
    if (this.error) drawText(ctx, this.error, GAME_WIDTH / 2, 1095, 22, COLORS.warning);
    this.drawButtons(ctx);
  }
}

module.exports = CosmeticsScene;
